module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_library.js
// module id = 145
// module chunks = 168707334958949